import { ComponentStyleConfig } from "@chakra-ui/react";
import { inputFieldDisabledProps } from "./input";

const Select: ComponentStyleConfig = {
  baseStyle: {
    field: {
      _disabled: inputFieldDisabledProps,
    },
    icon: {
      _disabled: {
        display: "none",
      },
    },
  },
};

export default Select;
